<template>
  <div class="official-container">
    <!-- 引入公共导航栏组件（替换原来的el-menu代码） -->
    <Navbar />

    <!-- 背景粒子效果 -->
    <!-- <Particles id="tsparticles" :options="options" /> -->
    <el-image src="/images/1.jpeg" fit="cover" class="feature-img" />

    <div class="content">
      <h1 style="font-size: 70px">AI一键成片</h1>
      <h1 style="font-size: 50px; margin: 20px">短剧/动画/推文一站式服务</h1>
      <p style="font-size: 20px ">AI智能易用的桌面端视频软件，让创作更简单</p>
      <!-- 下载按钮 -->
      <el-button type="primary" size="large" @click="handleDownload" :loading="isDownloading" class="download-btn" round
        style="background: linear-gradient(45deg, #409eff, #67c23a)">
        <el-icon><img
            src="//lf3-s.vlabstatic.com/obj/vilab-static/ies/ulike/web/resource/fe_official/svgs/windows_icon.007df4ff.svg"
            style="width: 20px; height: 20px" /></el-icon>
        立即下载
      </el-button>
      <p class="line--2dvbu">推荐Windows 10及以上64位系统</p>
    </div>

    <!-- 备案栏 -->
    <div class="footer">
      <p>
        <a href="https://beian.miit.gov.cn" target="_blank"> 2025 © 灵创 | 备案/许可证编号为：粤ICP备2025373993号 </a>
      </p>
      <p>公司名称： 韶关灵创科技有限公司</p>
    </div>

  </div>
</template>

<script setup>

import axios from 'axios';
import { ref } from 'vue';
import { ElMessage } from 'element-plus';
import Navbar from './Navbar.vue';

const UPDATE_SERVER = 'https://pcapi.lcapi.cn/desktop-update';
const isDownloading = ref(false);

// 从桌面端更新服务获取最新版本，并下载当前发布的安装包
const handleDownload = async () => {
  if (isDownloading.value) return;

  isDownloading.value = true;
  try {
    const res = await axios.get(`${UPDATE_SERVER}/latest`, {
      params: { t: Date.now() },
    });
    const versionInfo = res.data?.data;

    if (res.data?.msg !== 'success' || !versionInfo?.installerAvailable || !versionInfo?.downloadUrl) {
      throw new Error(res.data?.message || '最新版安装包暂未发布');
    }

    window.location.href = new URL(versionInfo.downloadUrl, UPDATE_SERVER).href;
  } catch (error) {
    ElMessage.error(error.response?.data?.message || error.message || '下载错误，请重试');
  } finally {
    isDownloading.value = false;
  }
};



const options = {
  background: {
    image: "url('https://221122-1338808597.cos.ap-guangzhou.myqcloud.com/Official/066.png')",
    position: "50% 50%",
    repeat: "no-repeat",
    size: "cover",
  },
  fpsLimit: 120,
  interactivity: {
    events: {
      onClick: { enable: true, mode: "push" },
      onHover: { enable: true, mode: "repulse" },
      resize: true,
    },
    modes: {
      bubble: { distance: 400, duration: 2, opacity: 0.8, size: 40 },
      push: { quantity: 4 },
      repulse: { distance: 200, duration: 0.4 },
    },
  },
  particles: {
    color: { value: "#fbc017" },
    links: { enable: false }, // 关闭粒子连线
    collisions: { enable: true },
    move: {
      direction: "none",
      enable: true,
      outMode: "bounce",
      random: true, // 随机方向移动
      speed: 1, // 降低速度
      straight: false,
    },
    number: {
      density: { enable: true, area: 800 },
      value: 150, // 增加粒子数量
    },
    opacity: {
      value: { min: 0.1, max: 0.5 }, // 设置透明度范围
      animation: {
        enable: true,
        speed: 1,
        sync: false,
        minimumValue: 0.1,
      },
    },
    shape: { type: "circle" },
    size: {
      random: true,
      value: { min: 1, max: 3 }, // 设置粒子大小范围
      animation: {
        enable: true,
        speed: 2,
        minimumValue: 1,
      },
    },
  },
  detectRetina: true,
};
</script>

<style scoped>
.official-container {
  position: relative;
  height: 100vh;
  overflow: hidden;
  background-color: #000;
}

/* 新增：配置背景图片样式（核心修改） */
.feature-img {
  /* 绝对定位：脱离文档流，不挤占后续内容空间 */
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  /* 铺满整个容器 */
  width: 100%;
  height: 100%;
  /* 层级低于content，避免覆盖文字和按钮 */
  z-index: 0;
  /* 可选：增加透明度，让文字更清晰 */
  opacity: 0.8;
}

.nav-bar {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  padding: 0 20px;
}

#particles-js {
  position: absolute;
  width: 100%;
  height: 100%;
  background-color: #000;
}

.content {
  position: relative;
  z-index: 1;
  text-align: center;
  padding-top: 20vh;
  color: white;
}

.title {
  font-size: 3rem;
  margin-bottom: 1rem;
}

.description {
  font-size: 1.5rem;
  margin-bottom: 2rem;
}

.download-btn {
  margin-top: 2rem;
  padding: 2rem 3rem;
  font-size: 1.6rem;
  border-radius: 50px;
}

.footer {
  position: absolute;
  bottom: 0;
  width: 100%;
  text-align: center;
  padding: 1rem 0;
  background-color: rgba(0, 0, 0, 0.8);
  color: white;
  z-index: 1;
}

.footer a {
  color: white;
  text-decoration: none;
}
</style>
